import React from 'react';
import autobind from "autobind-decorator";
import { PureComponent, Serialize } from 'core/components';
import { Card, CardHeader, CardContent } from 'core/components/Framework7';

import './styles.css';

class GroupBox extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { title, content, footer, padding, outline, noShadow, noBorder, className, children, style } = this.props

    return (
      <Card
        className={`groupBox ${className ? className : ''}`}
        style={style}
        title={title}
        content={content}
        footer={footer}
        padding={padding}
        outline={outline}
        noShadow={noShadow}
        noBorder={noBorder}
      >
        {children}
      </Card>
    )
  }
}

export default autobind(GroupBox);